import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { validateColorPreset } from '../../utils/presetValidator';
import '../../css/loadingDots.css';
var LoadingDots = function (props) {
    var _a, _b, _c;
    var className = props.className, dotColor = props.dotColor, dotSize = props.dotSize, vertical = props.vertical;
    var _d = useState(dotColor), _dotColor = _d[0], setDotColor = _d[1];
    var _e = useState(dotSize), _dotSize = _e[0], setDotSize = _e[1];
    useEffect(function () {
        if (dotColor !== undefined && validateColorPreset(dotColor)) {
            setDotColor(dotColor);
        }
    }, [dotColor]);
    useEffect(function () {
        if (dotSize !== undefined && ['small', 'medium', 'large'].includes(dotSize)) {
            setDotSize(dotSize);
        }
    }, [dotSize]);
    var _className = classNames('loading-dots', className, {
        'loading-dots--vertical': vertical,
    });
    var _dotOne = classNames('loading-dots__dot loading-dots__dot--1', (_a = {},
        _a["loading-dots__dot--".concat(_dotColor)] = _dotColor,
        _a["loading-dots__dot--".concat(_dotSize)] = _dotSize,
        _a));
    var _dotTwo = classNames('loading-dots__dot loading-dots__dot--2', (_b = {},
        _b["loading-dots__dot--".concat(_dotColor)] = _dotColor,
        _b["loading-dots__dot--".concat(_dotSize)] = _dotSize,
        _b));
    var _dotThree = classNames('loading-dots__dot loading-dots__dot--3', (_c = {},
        _c["loading-dots__dot--".concat(_dotColor)] = _dotColor,
        _c["loading-dots__dot--".concat(_dotSize)] = _dotSize,
        _c));
    return (React.createElement("div", { "data-test": 'loadingDots', className: _className },
        React.createElement("div", { className: _dotOne }),
        React.createElement("div", { className: _dotTwo }),
        React.createElement("div", { className: _dotThree })));
};
export default LoadingDots;
